import moment from 'moment'

export const caseStatuses = [
  {
    value: 'New', text: 'Новый', plural: 'Новые', color: 'secondary',
  },
  {
    value: 'InProgress', text: 'В работе', plural: 'В работе', color: 'info',
  },
  {
    value: 'Resolved', text: 'Решён', plural: 'Решённые', color: 'success',
  },
]

export const caseStatusColor = value => (caseStatuses.find(status => status.value === value) || {}).color || 'secondary'

export const COMMENT_MAX_LENGTH = 2000

export const firstLine = text => (text || '').split('\n')[0]

export const caseDateTime = value => (value ? moment(value).format('DD.MM.YYYY HH:mm') : '')

export const caseErrorText = (error, fallback) => {
  const data = error && error.response && error.response.data

  if (!data) return fallback

  const fields = data.validationErrors && Object.values(data.validationErrors)[0]

  return (fields && fields[0]) || data.message || data.title || fallback
}
